import React from 'react';

interface TabViewProps {
  pages: { content: JSX.Element }[];
  activeTab: number;
}

const TabView: React.FC<TabViewProps> = ({ pages, activeTab }) => {
  return <>{pages[activeTab]?.content}</>;
};

export default TabView;